"use strict";

exports.__esModule = true;
exports.default = void 0;

var _InputWidget = _interopRequireDefault(require("./InputWidget"));

var _ColorWidget = _interopRequireDefault(require("./ColorWidget"));

var _DateTimeWidget = _interopRequireDefault(require("./DateTimeWidget"));

var _DateWidget = _interopRequireDefault(require("./DateWidget"));

var _TimeWidget = _interopRequireDefault(require("./TimeWidget"));

var _TextWidget = _interopRequireDefault(require("./TextWidget"));

var _TextareaWidget = _interopRequireDefault(require("./TextareaWidget"));

var _TexteditorWidget = _interopRequireDefault(require("./TexteditorWidget"));

var _PasswordWidget = _interopRequireDefault(require("./PasswordWidget"));

var _EmailWidget = _interopRequireDefault(require("./EmailWidget"));

var _WidgetUrl = _interopRequireDefault(require("./WidgetUrl"));

var _CodeWidget = _interopRequireDefault(require("./CodeWidget"));

var _SelectWidget = _interopRequireDefault(require("./SelectWidget"));

var _CheckboxWidget = _interopRequireDefault(require("./CheckboxWidget"));

var _CheckboxesWidget = _interopRequireDefault(require("./CheckboxesWidget"));

var _SwitchWidget = _interopRequireDefault(require("./SwitchWidget"));

var _WidgetUpDown = _interopRequireDefault(require("./WidgetUpDown"));

var _SliderWidget = _interopRequireDefault(require("./SliderWidget"));

var _RadiogroupWidget = _interopRequireDefault(require("./RadiogroupWidget"));

var _AutocompleteWidget = _interopRequireDefault(require("./AutocompleteWidget"));

var _WidgetMdIcon = _interopRequireDefault(require("./WidgetMdIcon"));

var _IconWidget = _interopRequireDefault(require("./IconWidget"));

var _TagsWidget = _interopRequireDefault(require("./TagsWidget"));

var _IsoLanguageWidget = _interopRequireDefault(require("./IsoLanguageWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "fieldtypes": {},
  "fields": {},
  "layouts": {},
  "widgets": {
    "text": _TextWidget.default,
    "textarea": _TextareaWidget.default,
    "texteditor": _TexteditorWidget.default,
    "editor": _TexteditorWidget.default,
    "number": _InputWidget.default,
    "password": _PasswordWidget.default,
    "uri": _WidgetUrl.default,
    "data-url": _WidgetUrl.default,
    "hostname": _InputWidget.default,
    "ipv4": _InputWidget.default,
    "ipv6": _InputWidget.default,
    "email": _EmailWidget.default,
    "color": _ColorWidget.default,
    "range": _SliderWidget.default,
    "updown": _WidgetUpDown.default,
    "select": _SelectWidget.default,
    "autocomplete": _AutocompleteWidget.default,
    "radio": _RadiogroupWidget.default,
    "code": _CodeWidget.default,
    "datetime": _DateTimeWidget.default,
    "date": _DateWidget.default,
    "time": _TimeWidget.default,
    "date-time": _DateTimeWidget.default,
    "alt-date": _DateWidget.default,
    "alt-datetime": _TimeWidget.default,
    "checkbox": _CheckboxWidget.default,
    "checkboxes": _CheckboxesWidget.default,
    "switch": _SwitchWidget.default,
    "size": _SelectWidget.default,
    "grid": _SelectWidget.default,
    "mdIcon": _WidgetMdIcon.default,
    "icon": _IconWidget.default,
    "tags": _TagsWidget.default,
    "isoLanguage": _IsoLanguageWidget.default
  }
};
exports.default = _default;
module.exports = exports.default;